export default __webpack_public_path__ + "static/media/attributes.b72238f7.svg";